
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/[post]",
      function () {
        return require("private-next-pages/[category]/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/[post]"])
      });
    }
  